export default __webpack_public_path__ + "static/media/carousel2.2e98f97f.png";